import script from "./BusySpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./BusySpinner.vue?vue&type=script&setup=true&lang=js"

import "./BusySpinner.vue?vue&type=style&index=0&id=6ec2a109&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec2a109"]])

export default __exports__